"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onlyUnique = onlyUnique;
/**
 * Filter an array of value with unique value only
 * @example
 * [1,2,1,4,3].filter(onlyUnique);
 *
 * @param value
 * @param index
 * @param self
 * @returns {boolean}
 */
function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}